export const REGEX = {
  ENVIRONMENTS: new RegExp('dev|test|qa|local|ist|uat'),
};
